module.exports = __webpack_public_path__ + "static/media/EmotionalDiffusionTechniques.d8341879.mp3";